export default __webpack_public_path__ + "static/media/savedSearchIcon.ec9e214d.svg";